<template>
    <div :class="{'inline': inline}">
        <x-label color="primary" :title="title">
            <i class="fa fa-commenting-o" /> SMS blast
        </x-label>
    </div>
</template>

<style lang="scss" scoped>
    .inline {
        display: inline-block;
    }
</style>

<script>
import XLabel from './XLabel.vue'
export default {
    components: { XLabel },
    props: {
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        title: {
            type: String,
            required: false,
            default: 'SMS blast aktif',
        },
    },
}
</script>